import { observer } from "mobx-react-lite";
import Search from "./Search";
import filterStore from "../services/FilterStore";
import { useRouter } from "next/router";

export const GlobalSearch = observer(
  ({ className, ...props }: { className?: string }) => {
    const router = useRouter();
    const store = filterStore;
    const GLOBAL_SEARCH_ID = "global-search-input";
    const onSubmit = () => {
      if (router.pathname !== "/" && store.searchText.trim() !== "") {
        router.push({
          pathname: "/",
          query: { search: store.searchText },
        });
      }
    };
    return <Search store={store} id={GLOBAL_SEARCH_ID} onSubmit={onSubmit} />;
  }
);
export default GlobalSearch;
